(function () {
  'use strict';
  if (window.palmrFitLinksBound) return;
  window.palmrFitLinksBound = true;

  function selectedFit(group) {
    var scope = group.closest('.js-product') || group.closest('.shopify-section') || document;
    var inputs = scope.querySelectorAll('variant-picker input:checked, variant-picker select option:checked');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === 'Standard' || inputs[i].value === 'Small Fit') return inputs[i].value;
    }
    return group.dataset.pgFit;
  }

  function updateLink(link, fit) {
    var variants;
    try { variants = JSON.parse(link.dataset.pgVariants); } catch (e) { return false; }
    var variant = variants.find(function (item) { return item.options.indexOf(fit) !== -1; });
    if (variant) {
      var url = new URL(link.dataset.pgUrl, window.location.origin);
      url.searchParams.set('variant', variant.id);
      link.setAttribute('href', url.pathname + url.search);
    } else {
      link.removeAttribute('href');
    }
    var available = Boolean(variant && variant.available);
    link.setAttribute('aria-disabled', String(!available));
    link.setAttribute('role', 'link');
    link.setAttribute('tabindex', '0');
    return available;
  }

  function syncGroups() {
    document.querySelectorAll('.palmr-pg[data-pg-fit]').forEach(function (group) {
      var fit = selectedFit(group);
      group.querySelectorAll('[data-pg-fit-link]').forEach(function (link) { updateLink(link, fit); });
      var notice = group.querySelector('[data-pg-fit-notice]');
      if (notice) notice.hidden = true;
    });
  }

  function handleLink(event) {
    var link = event.target.closest('[data-pg-fit-link]');
    if (!link) return;
    var group = link.closest('.palmr-pg');
    var fit = selectedFit(group);
    if (updateLink(link, fit)) return;
    event.preventDefault();
    var notice = group.querySelector('[data-pg-fit-notice]');
    notice.textContent = group.dataset.fitUnavailable.replace('[fit]', fit);
    notice.hidden = false;
  }

  document.addEventListener('click', handleLink, true);
  document.addEventListener('auxclick', handleLink, true);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && event.target.matches('[data-pg-fit-link]:not([href])')) handleLink(event);
  }, true);
  document.addEventListener('change', syncGroups);
  document.addEventListener('on:variant:change', syncGroups);
  window.addEventListener('pageshow', syncGroups);
  syncGroups();
})();
